import { rollupStatementEnvelopeSchema, type RollupStatementResponse } from '@emr/shared';

import { apiRequest } from './client.ts';

export type { RollupStatementResponse };

/** `GET /api/reseller/rollup-statement` (`BACKLOG.md` T17) — `org:read_children`. */
export async function fetchRollupStatement(signal?: AbortSignal): Promise<RollupStatementResponse> {
  const response = await apiRequest(
    '/api/reseller/rollup-statement',
    rollupStatementEnvelopeSchema,
    signal === undefined ? {} : { signal },
  );
  return response.rollupStatement;
}
